export enum CaptchaEndpoints {
  GetCaptcha = 'GetCaptcha',
  TestCaptcha = 'TestCaptcha',
}

export interface ModelCaptcha {
  Id: string | null;
  FormulaResult: number;
  Captcha: string | null;
  Lifetime: string;
  TestResult: boolean;
}

// Captcha вызывается только до авторизации (вход, регистрация), поэтому
// запросы идут без ActiveBranchId. В swagger параметр необязательный.
export type GetCaptchaRequest = {
  minLifetime?: number;
};

export type TestCaptchaRequest = {
  captchaId?: string;
  formulaResult?: number;
  minLifetime?: number;
};

export type GetCaptchaResponse = ModelCaptcha;
export type TestCaptchaResponse = ModelCaptcha;
